import React from 'react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';

const MentorshipPage = () => {
  return (
    <div>
      <Navbar />
      
      <div className="page-header" style={{ background: 'linear-gradient(135deg, var(--primary), var(--accent))' }}>
        <div className="container" style={{ color: 'white' }}>
          <h1 style={{ color: 'white' }} data-testid="page-title">UPSC 2026 Mentorship Program</h1>
          <p style={{ opacity: 0.95 }}>Personalized Guidance for Your Success Journey</p>
        </div>
      </div>

      <section className="py-8 container">
        <h2 style={{ marginBottom: '2rem', textAlign: 'center' }}>About the Mentorship Program</h2>
        <div className="card">
          <p style={{ fontSize: '1.125rem', lineHeight: 1.8, color: 'var(--muted-foreground)' }}>
            Our UPSC 2026 Mentorship Program offers one-on-one guidance from experienced mentors who have successfully navigated the UPSC journey. Get personalized study plans, regular progress tracking, and strategic advice tailored to your strengths and weaknesses.
          </p>
        </div>
      </section>

      <section className="py-8" style={{ background: 'var(--secondary)' }}>
        <div className="container">
          <h2 style={{ marginBottom: '3rem', textAlign: 'center' }}>3-Phase Structured Journey</h2>
          <div className="grid grid-3">
            <div className="card" data-testid="phase-1">
              <div style={{ width: '60px', height: '60px', borderRadius: '50%', background: 'var(--primary)', color: 'white', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '1.5rem', fontWeight: 700, marginBottom: '1rem' }}>1</div>
              <h3 style={{ marginBottom: '1rem' }}>Foundation Phase</h3>
              <p style={{ color: 'var(--muted-foreground)' }}>Build strong basics with NCERT coverage and concept clarity. Duration: 3 months</p>
            </div>
            <div className="card" data-testid="phase-2">
              <div style={{ width: '60px', height: '60px', borderRadius: '50%', background: 'var(--primary)', color: 'white', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '1.5rem', fontWeight: 700, marginBottom: '1rem' }}>2</div>
              <h3 style={{ marginBottom: '1rem' }}>Consolidation Phase</h3>
              <p style={{ color: 'var(--muted-foreground)' }}>Practice with tests, current affairs integration, and revision. Duration: 3 months</p>
            </div>
            <div className="card" data-testid="phase-3">
              <div style={{ width: '60px', height: '60px', borderRadius: '50%', background: 'var(--primary)', color: 'white', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '1.5rem', fontWeight: 700, marginBottom: '1rem' }}>3</div>
              <h3 style={{ marginBottom: '1rem' }}>Prelims Preparation</h3>
              <p style={{ color: 'var(--muted-foreground)' }}>Full-length mocks, final revision, and exam strategy. Duration: 2 months</p>
            </div>
          </div>
        </div>
      </section>

      <section className="py-8 container">
        <h2 style={{ marginBottom: '3rem', textAlign: 'center' }}>Program Highlights</h2>
        <div className="grid grid-2">
          {[
            { icon: '👤', title: 'One-to-One Mentorship', desc: 'Dedicated mentor for personalized guidance' },
            { icon: '📋', title: 'Customized Study Plan', desc: 'Tailored to your pace and learning style' },
            { icon: '📞', title: 'Weekly Check-ins', desc: 'Regular progress monitoring and feedback' },
            { icon: '📚', title: 'Study Material Provided', desc: 'Curated resources and notes' },
            { icon: '💬', title: '24/7 Doubt Support', desc: 'WhatsApp group for instant clarifications' },
            { icon: '🎯', title: 'Strategy Sessions', desc: 'Exam approach and time management tips' }
          ].map((item, idx) => (
            <div key={idx} className="card" data-testid={`highlight-${idx}`}>
              <div style={{ fontSize: '2.5rem', marginBottom: '1rem' }}>{item.icon}</div>
              <h3 style={{ marginBottom: '0.5rem' }}>{item.title}</h3>
              <p style={{ color: 'var(--muted-foreground)' }}>{item.desc}</p>
            </div>
          ))}
        </div>
      </section>

      <section className="py-8" style={{ background: 'var(--secondary)' }}>
        <div className="container text-center">
          <h2 style={{ marginBottom: '1.5rem' }}>Ready to Enroll in All Our Programs?</h2>
          <p style={{ color: 'var(--muted-foreground)', marginBottom: '2rem', fontSize: '1.125rem' }}>
            Get access to NCERT Mastery, Adhva Vibes PSI, and Mentorship Program
          </p>
          <a 
            href="https://forms.gle/5mjmuxov7LaYCHTU6" 
            target="_blank" 
            rel="noopener noreferrer" 
            className="btn-primary" 
            style={{ fontSize: '1.1rem', padding: '1rem 2.5rem' }}
          >
            Enroll Now →
          </a>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default MentorshipPage;